   function addToCart(event) {
      const sizesPopup = event.target.parentElement.parentElement
      const icon = sizesPopup.previousSibling.previousSibling
      const iconBagImg = [...icon.childNodes].find(e => e.classList && e.classList.contains('icon-bag'))
      event.preventDefault()
      variantId = event.target.getAttribute("data-id")
      let formData = {
          'items': [{
          'id': variantId,
          'quantity': 1
          }]
      };

      // animateElement(icon, 'bag-icon-active', 'bag-icon-hide')
      // animateElement(sizesPopup, 'sizes-popup-active')
      // iconBagImg.src = imagesObj.loader
      // animateElement(iconBagImg, 'bag-icon-loader')

      fetch('/cart/add.js', {
          method: 'POST',
          headers: {
          'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
      })
      .then(response => response.json())
      .then(cart => {
          if (cart.status === 404)throw new Error 
          else {
          // iconBagImg.src = imagesObj.success
          // animateElement(iconBagImg, 'bag-icon-loader')
          
          document.documentElement.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true }));
         
          //$('body').trigger('added.ajaxProduct', event);
          //$('#bottom-popup-wrapper').css('bottom', '0')

          setTimeout(() => {
              // iconBagImg.src = imagesObj.bag
          }, 2000)
          
          setTimeout(() => {
              //$('#bottom-popup-wrapper').css('bottom', '-100px')
          }, 3000)
          }
      })
      .catch(error => {
          console.error('Error:', error)
      })
  }
document.addEventListener('DOMContentLoaded', function() {
 



  
    function popup_size(clickedElement){
      if (clickedElement.matches('.size-popup-exit-icon-wrapper')) {
          // event.preventDefault();
        console.log("df")
        var sizesProductId =  clickedElement.getAttribute('data-size-id');

        
        

        
        document.querySelectorAll(`[data-size-id="${sizesProductId}"]`).forEach(otf => {
            otf.classList.remove("sizes-popup-active");
        }); 
        var bgi = document.querySelector(`.varinats-size-show[data-size-id="${sizesProductId}"]`)
        bgi.classList.remove("bag-icon-active");
        bgi.classList.remove("bag-icon-hide");
        // event.preventDefault();
        
            setTimeout(() => {
                document.querySelector(`a.${sizesProductId}`).setAttribute('href', clickedElement.getAttribute('data-url'));
                console.log('Href set after delay');
            }, 1000);         
        
      }else if (clickedElement.matches('.varinats-size-show')) {
          event.preventDefault();
        
          document.querySelectorAll(`.varinats-size-show`).forEach(otf => {
              otf.classList.remove("sizes-popup-active");
              otf.classList.remove("bag-icon-active");
              otf.classList.remove("bag-icon-hide");
          });
          clickedElement.classList.add("bag-icon-active");
          clickedElement.classList.add("bag-icon-hide");
          
          document.querySelectorAll(`.sizes-popup`).forEach(otf => {
                otf.classList.remove("sizes-popup-active");
            });
        

          var sizesProductId =  clickedElement.getAttribute('data-size-id');
       
        
          document.querySelectorAll(`.sizes-popup[data-size-id="${sizesProductId}"]`).forEach(otf => {
                otf.classList.add("sizes-popup-active");
            });

                    document.querySelector(`a.${sizesProductId}`).removeAttribute('href');
        
        }else if (clickedElement.matches('.size-popup-exit-icon-wrapper')) {
          event.preventDefault();
          
        }
    } 
    document.addEventListener('click', function(event) {
      const clickedElement = event.target;
      popup_size(clickedElement);
      
    });
  document.addEventListener('mouseover', function(event) {
      const clickedElement = event.target;
      popup_size(clickedElement);
  });
});
